import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Footer.css';
import { XrplNetworkUrls } from './Constants';

const Footer = () => {
  return (
    <footer className="Footer">
      <div className="container">
        <Row>
          <Col sm={12} md>
            <h5>Powered by XRP Ledger</h5>
            <p>XRPSCAN is the leading explorer for the XRP Ledger, the home of XRP.</p>
          </Col>
          <Col sm="12" md>
            <h5>Explore</h5>
            <ul className="list-unstyled">
              <li><Link to={`/search`} className="footer-link">Quick search</Link></li>
              <li><Link to={`/metrics`} className="footer-link">XRPL metrics</Link></li>
              <li><Link to={`/amendments`} className="footer-link">Amendments</Link></li>
              <li><Link to={`/validators`} className="footer-link">Validator registry</Link></li>
              <li><Link to={`/balances`} className="footer-link">XRP Rich List</Link></li>
              <li><Link to={`/amms`} className="footer-link">AMM Pools</Link></li>
              <li><Link to={`/oracles`} className="footer-link">Price Oracles</Link></li>
              <li><Link to={`/tokens`} className="footer-link">Token directory</Link></li>
              <li><Link to={`/mptokens`} className="footer-link">MPTokens</Link></li>
            </ul>
          </Col>
          <Col sm="12" md>
            <h5>Support</h5>
            <ul className="list-unstyled">
              <li><a href="mailto:support@xrpscan.com" className="footer-link">support@xrpscan.com</a></li>
              <li><a href="https://docs.xrpscan.com/" target="_blank" rel="noopener noreferrer nofollow" className="footer-link">Documentation</a></li>
              <li><a href="https://docs.xrpscan.com/api-documentation/introduction" target="_blank" rel="noopener noreferrer nofollow" className="footer-link">API Docs</a></li>
              <li><a href="https://docs.xrpscan.com/help/contact-us" target="_blank" rel="noopener noreferrer nofollow" className="footer-link">Contact us</a></li>
              <li><a href="https://docs.xrpscan.com/help/privacy-policy" target="_blank" rel="noopener noreferrer nofollow" className="footer-link">Privacy policy</a></li>
              <li><a href="https://docs.xrpscan.com/help/terms-of-service" target="_blank" rel="noopener noreferrer nofollow" className="footer-link">Terms of service</a></li>
              <li><a href="https://status.xrpscan.com/" target="_blank" rel="noopener noreferrer nofollow" className="footer-link">Status page</a></li>
            </ul>
          </Col>
          <Col sm="12" md>
            <h5>Services</h5>
            <ul className="list-unstyled">
              <li><a href="https://xrptoolbox.com" target="_blank" rel="noopener noreferrer" className="footer-link">XRP Toolbox</a></li>
              <li><a href="https://console.xrpscan.com" target="_blank" rel="noopener noreferrer" className="footer-link">Advanced Search Console</a></li>
              <li><a href="https://docs.xrpscan.com/help/integration-guide" target="_blank" rel="noopener noreferrer nofollow" className="footer-link">Integration guide</a></li>
              <li><a href={XrplNetworkUrls.XrplMainnet} target="_blank" rel="noopener noreferrer nofollow" className="footer-link">Mainnet Explorer</a></li>
              <li><a href={XrplNetworkUrls.XrplTestnet} target="_blank" rel="noopener noreferrer nofollow" className="footer-link">Testnet Explorer</a></li>
            </ul>
          </Col>
          <Col sm="12" md className="text-center">
            <h5>Social</h5>
            <ul className="list-inline">
              <li className="list-inline-item"><a href="https://x.com/xrpscan" target="_blank" rel="noopener noreferrer nofollow" className="footer-link"><FontAwesomeIcon icon={['fab','twitter']} size="lg"/></a></li>
              <li className="list-inline-item"><a href="https://www.reddit.com/user/xrpscan" target="_blank" rel="noopener noreferrer nofollow" className="footer-link"><FontAwesomeIcon icon={['fab','reddit']}  size="lg"/></a></li>
              <li className="list-inline-item"><a href="mailto:support@xrpscan.com" className="footer-link"><FontAwesomeIcon icon="at" size="lg"/></a></li>
              <li className="list-inline-item"><a href="https://github.com/xrpscan" target="_blank" rel="noopener noreferrer nofollow" className="footer-link"><FontAwesomeIcon icon={['fab','github']} size="lg"/></a></li>
              <li className="list-inline-item"><a href="https://www.instagram.com/xrpscan" target="_blank" rel="noopener noreferrer nofollow" className="footer-link"><FontAwesomeIcon icon={['fab','instagram']} size="lg"/></a></li>
              <li className="list-inline-item"><a href="https://www.threads.net/@xrpscan" target="_blank" rel="noopener noreferrer nofollow" className="footer-link"><FontAwesomeIcon icon={['fad','scribble']} size="lg"/></a></li>
            </ul>
          </Col>
        </Row>
        <Row>
          <Col className="text-center">
            <small>&copy; 2017 - 2026 Scrambled Egg Technologies. All rights reserved.</small>
          </Col>
        </Row>
      </div>
    </footer>
  );
}

export default Footer;
